'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const memoize = require('just-memoize');
const objectHash = require('object-hash');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

const memoize__default = /*#__PURE__*/_interopDefault(memoize);
const objectHash__default = /*#__PURE__*/_interopDefault(objectHash);

const hash = memoize__default["default"](
  (...args) => objectHash__default["default"](args, { unorderedObjects: false }).replace(/^(\d)/, "a$1")
);

exports.hash = hash;
